import { PUBLIC_DOMAINS } from "../config";

export const convertInternalLink = (url) => {
  if (typeof url !== 'string') {
    return url;
  }

  let finalLink = url;
  try {
    const urlObj = new URL(url);
    if (PUBLIC_DOMAINS.includes(urlObj.host)) {
      finalLink = url.slice(urlObj.origin.length);
    }
  } catch (err) { } // eslint-disable-line no-empty

  return finalLink;
};
